// import { v4 as uuidv4 } from 'uuid';

import { tagsActions, tagsTypes } from 'app-components/flux/tags';
import store from 'app-components/utils/redux-store';

import deterministicGuid from './deterministicGuid';
import { mergeMintImportSharedState } from './mintImportSharedState';

const importTags = async (fileJS) => {
  const key = 'TAGS';
  let simplifiTagsByMintId;
  try {
    const mintTagsById = fileJS.tags.reduce((result, tag) => {
      const mintTag = {
        ...tag,
        // clientId: uuidv4().toUpperCase(),
        clientId: deterministicGuid(tag.id),
      };
      return result.set(tag.id, mintTag);
    }, new Map());
    mergeMintImportSharedState({ key, progress: 20 });

    let tagsResponse;
    if (mintTagsById?.size) {
      tagsResponse = await new Promise((resolve, reject) => {
        store.dispatch(
          tagsActions.batchTags(
            [...mintTagsById.values()].map((mintTag) =>
              tagsTypes.mkTag({
                clientId: mintTag.clientId,
                name: mintTag.name,
              }),
            ),
            { resolve, reject },
          ),
        );
      });

      mergeMintImportSharedState({ key, progress: 80 });

      simplifiTagsByMintId = tagsResponse.data.items.reduce((simplifiTags, simplifiTag) => {
        const mintTagFound = [...mintTagsById.values()].find(
          (mintLogin) => mintLogin.clientId === simplifiTag.resource.clientId,
        );
        assert(mintTagFound, 'mint tag not found', { simplifiTag });
        return mintTagFound
          ? simplifiTags.set(mintTagFound.id, tagsTypes.mkTag(simplifiTag.resource.resource))
          : simplifiTags;
      }, new Map());
    } else {
      simplifiTagsByMintId = new Map();
    }

    mergeMintImportSharedState({ key, progress: 100, [key]: { importedCount: simplifiTagsByMintId.size } });
  } catch (error) {
    assert(false, error);
    mergeMintImportSharedState({ error: key, [key]: { error } });
  }

  return simplifiTagsByMintId;
};

export default importTags;
